import { Component, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';


@Component({
  moduleId: module.id,
  selector: 'default-modal',
  templateUrl: 'default-modal.component.html',
  styleUrls: ['default-modal.component.scss'],
})
export class DefaultModalComponent {
  /*
    * Bootstrap modal options:
    * http://valor-software.com/ngx-bootstrap/index-bs4.html#/modals#modal-options
  */

  @Input() overflow: boolean = false;

  @Input() backdrop: boolean | string = true;

  @Input() ignoreBackdropClick: boolean = false;

  @Input() keyboard: boolean = true;

  @Input() initializedShow: boolean = false;

  @Input() ghostValue: string;

  @Output() onHide: EventEmitter<any> = new EventEmitter();

  @Output() onShow: EventEmitter<any> = new EventEmitter();

  @ViewChild('defaultModal', {static: false}) defaultModal: ModalDirective | void;

  public show(): void {
    if (this.defaultModal instanceof ModalDirective) {
      this.defaultModal.show();
    }
  }

  public hide(): void {
    if (this.defaultModal instanceof ModalDirective) {
      this.defaultModal.hide();
    }
  }

  // handlers
  onShowModal(event: any) {
    this.onShow.emit(event);
  }

  onHideModal(event: any) {
    this.onHide.emit(event);
  }

}
